import { Component, OnInit, ViewChild} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { FORMJOBDATA } from "@component/careers/apply-job-dialog/apply-job.model";
import { ApiService } from "@shared/services/api.service";
import { Urls } from "@root/utils/urls";
import { NgForm } from "@angular/forms";
import { MAX_RESUME_PDF_SIZE, Unsupported_file_format, Maximum_file_upload_size_should_be_1MB } from "@root/app.constant";
import { FileInputComponent } from '@common/file-input/file-input';

@Component({
  selector: "app-apply-job-dialog",
  templateUrl: "./apply-job-dialog.component.html",
  styleUrls: ["./apply-job-dialog.component.scss"],
})
export class ApplyJobDialogComponent implements OnInit {

  @ViewChild("f", { static: false }) form: NgForm;

  @ViewChild(FileInputComponent, { static: false }) fileInputComponent: FileInputComponent;


  applyJobData = new FORMJOBDATA();

  emailPattern = "[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}";

  fileName: string;

  mobNumberPattern = "^((\\+91-?)|0)?[6-9][0-9]{9}$";

  constructor(
    private toastr: ToastrService, 
    public apiService: ApiService) {}

  ngOnInit() {}

  public onFileChange(file: File) {
    const isValid =  this.isValidFile(file);
    if (isValid) {
      this.applyJobData.file = file;
    } else {
      this.fileName =null;
      this.applyJobData.file = null
    }
  }

  public isValidFile(file: File){
    let isValid = !!file;
    if(isValid){
      if (file.type !== "application/pdf") {
        this.toastr.error(Unsupported_file_format);
        isValid = false;
      }

      if (isValid && file.size > MAX_RESUME_PDF_SIZE) {
        this.toastr.error(Maximum_file_upload_size_should_be_1MB);
        isValid = false;
      }

      if(!isValid){
        setTimeout(()=>{
          this.clearFileInput();
        })
      }
    }

    return isValid;
  }

  public clearFileInput(){
      if(this.fileInputComponent){
        this.fileInputComponent.clear();
      }
  }


  public processData() {
    const formData = new FormData();
    formData.append("file", this.applyJobData.file);
    formData.append("name", this.applyJobData.name);
    formData.append("mobileNumber", this.applyJobData.mobileNumber);
    formData.append("emailId", this.applyJobData.emailId);
    formData.append("positionApplied", this.applyJobData.positionApplied);
    formData.append("message", this.applyJobData.message);

    this.apiService.postData(Urls.postCareers, formData).subscribe(
      (response) => {
        if (response.status === 0) {
          this.toastr.success(
            "We received your resume... Our team will review and get back to you!",
            "Thank You!"
          );
          this.resetForm();
        } else {
          this.toastr.error("Please try again!", "Something went wrong!");
        }
      },
      (error) => {}
    );
  }

  public resetForm() {
    this.form.resetForm();
  }


   /**
   * 
   * Phone validation
   */
  keyPressPhone(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  
  /***
   * Name position validation
   */
  keyPressAlpha(event: any) {
    const pattern = /[a-zA-Z ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
